import { render } from "./NotFound.vue?vue&type=template&id=007ca80c"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=007ca80c&lang=css"
script.render = render

export default script